import { useCallback, useEffect, useState } from "react";
import { getHomeOverview } from "@/api/tenantDashboardApi";
import { useWorkspace } from "@/contexts/WorkspaceContext";

export function useHomeOverview() {
  const { activeWorkspaceId } = useWorkspace();
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(/** @type {Error | null} */ (null));

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await getHomeOverview();
      setOverview(data);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setOverview(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!activeWorkspaceId) {
      setOverview(null);
      setLoading(false);
      setError(null);
      return;
    }
    void refresh();
  }, [refresh, activeWorkspaceId]);

  return { overview, loading, error, refresh };
}
